import { clientsApi } from '@/admin/api';
import { ClientDetail } from '@/admin/pages/clients/client-detail';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/_app/clients/$clientId')({
	loader: ({ context, params }) =>
		context.queryClient.ensureQueryData({
			queryKey: ['client', params.clientId],
			queryFn: () => clientsApi.get(Number(params.clientId)),
		}),
	wrapInSuspense: true,
	component: ClientDetail,
});
